import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RpcError, StatusCode } from 'grpc-web';
import { UserEndpointClient } from '../../../../../../repository/UserManagement/Customers/UserServiceClientPb';
import { API_URL, getCurrentLng, getHeaders, ApiMessage, toApiMessage, APIResponse, refreshSession, getSession, ACCOUNTANT_API_URL, APIRequest, TRADING_API_URL } from '../../../../../../app/Api';
import { formatDate, timestampToDate } from '../../../../../../app/Helpers';

import { TableState } from '../../../../../common/Table/TableSate';
import { number } from 'yup';
import { OrderEndpointClient } from '../../../../../../repository/Trading/OrderServiceClientPb';
import { OrderTransactionEndpointClient } from '../../../../../../repository/Trading/OrderTransactionServiceClientPb';
import { GetOrderTransactionsResponse, GetOrderTransactionsRequest, UpdateOrderTransactionStateResponse, UpdateOrderTransactionStateRequest } from '../../../../../../repository/Trading/orderTransaction_pb';
import { GetUsersRequest, GetUsersResponse } from '../../../../../../repository/UserManagement/Customers/user_pb';
import { CurrencyPairEndpointClient } from '../../../../../../repository/Trading/Currency_pairServiceClientPb';
import { GetCurrencyPairsRequest, GetCurrencyPairsResponse } from '../../../../../../repository/Trading/currency_pair_pb';
import { DynamicField } from '../../../../../common/DynamicFields/DynamicFields';
import { OrderAction } from '../../../../../../app/Enums';


export interface TradeHistoryPageState {
    set: TableState
    isChangeStateLoading: boolean,
    message?: ApiMessage,
    searchText: string | undefined,
    filters: any[],
    clients: TableState
    fromFilterOption: { value: string, text: string },
    toFilterOption: { value: string, text: string },

}

const initialState: TradeHistoryPageState = {
    set: { items: [], hasMore: true, isDescending: true, isFetching: false, numberOfResults: 10, selected: [], isFilteredSet: false },
    isChangeStateLoading: false,
    message: undefined,
    searchText: undefined,
    filters: [],
    clients: { items: [], hasMore: true, isDescending: true, isFetching: false, numberOfResults: 10, selected: [], isFilteredSet: false },
    fromFilterOption: { value: "", text: "" },
    toFilterOption: { value: "", text: "" },

}

const client = new OrderEndpointClient(TRADING_API_URL, null, null);
const clientOrderTrx = new OrderTransactionEndpointClient(TRADING_API_URL, null, null);
const clienCustomers = new UserEndpointClient(API_URL, null, null);

export const getItems = createAsyncThunk<GetOrderTransactionsResponse.AsObject, APIRequest<GetOrderTransactionsRequest>, {

    rejectValue: ApiMessage
}>(
    'pages/trading/orderDetails/orderTransactions/fetch',
    async (req, thunkApi) => {
        let callReq = async (): Promise<any> => {
            try {

                var r = await clientOrderTrx.getOrderTransactions(req.body, req.headers ?? {});
                return r.toObject();
            } catch (err) {
                try {
                    let message = toApiMessage((err as RpcError).metadata);
                    if (message.data == 401) {
                        var isSessionRefreshed = await refreshSession();
                        if (isSessionRefreshed) {
                            req.headers = {
                                ...req.headers,
                                "Authorization": 'Bearer ' + getSession().accesstoken?.token?.value,
                            }
                            return await callReq();
                        }
                    }
                    return thunkApi.rejectWithValue(message)
                } catch (err) {

                    return thunkApi.rejectWithValue({ body: "genericErrorBody", data: "", title: "genericErrorTitle", type: -2 } as ApiMessage)
                }
            }
        }
        return await callReq();
    }

)



export const getClinetUsers = createAsyncThunk<GetUsersResponse.AsObject, APIRequest<GetUsersRequest>, {
    rejectValue: ApiMessage
}>(
    'pages/trading/orderDetails/orderTransactions/clients/fetch',
    async (req, thunkApi) => {

        let callReq = async (): Promise<any> => {
            try {
                var r = await clienCustomers.getUsers(req.body, req.headers ?? {});
                return r.toObject();
            } catch (err) {
                try {
                    let message = toApiMessage((err as RpcError).metadata);
                    if (message.data == 401) {
                        var isSessionRefreshed = await refreshSession();
                        if (isSessionRefreshed) {
                            req.headers = {
                                ...req.headers,
                                "Authorization": 'Bearer ' + getSession().accesstoken?.token?.value,
                            }
                            return await callReq();
                        }
                    }
                    return thunkApi.rejectWithValue(message)
                } catch (err) {
                    return thunkApi.rejectWithValue({ body: "genericErrorBody", data: "", title: "genericErrorTitle", type: -2 } as ApiMessage)
                }
            }
        }
        return await callReq();
    }

)

export const updateStatus = createAsyncThunk<APIResponse<UpdateOrderTransactionStateResponse.AsObject>, APIRequest<UpdateOrderTransactionStateRequest>, {

    rejectValue: ApiMessage
}>(
    'pages/trading/orderDetails/orderTransactions/updateStatus',
    async (req, thunkApi) => {
        let callReq = async (): Promise<any> => {

            try {
                var r = await clientOrderTrx.updateState(req.body, req.headers ?? {});
                return { metadata: { id: req.body.getId(), status: req.body.getStatus(), current: req.metadata }, response: r.toObject() };
            } catch (err) {
                try {
                    let message = toApiMessage((err as RpcError).metadata);
                    if (message.data == 401) {
                        var isSessionRefreshed = await refreshSession();
                        if (isSessionRefreshed) {
                            req.headers = {
                                ...req.headers,
                                "Authorization": 'Bearer ' + getSession().accesstoken?.token?.value,
                            }
                            return await callReq();
                        }
                    }
                    return thunkApi.rejectWithValue(message)
                } catch (err) {

                    return thunkApi.rejectWithValue({ body: "genericErrorBody", data: "", title: "genericErrorTitle", type: -2 } as ApiMessage)
                }
            }

        }
        return await callReq();
    }
)


const getFilters = (state: TradeHistoryPageState): any[] => {
    const selected = [];


    if (state.clients.selected.length > 0) {
        selected.push({ key: 2, name: state.clients.selected.at(0).name });
    }

    if (state.fromFilterOption.value && state.fromFilterOption.value != "") {
        selected.push({ key: 6, name: state.fromFilterOption.text });
    }
    if (state.toFilterOption.value && state.toFilterOption.value != "") {
        selected.push({ key: 7, name: state.toFilterOption.text });
    }


    return selected;
}

export const orderTransactionsPageSlice = createSlice({
    name: 'trading/orderDetails/orderTransactions',
    initialState,
    reducers: {
        dismissMessage: (state) => {
            state.message = undefined;
        },
        reset: (state) => {
            state.message = initialState.message;
            state.set = initialState.set;
            state.isChangeStateLoading = initialState.isChangeStateLoading;
            state.searchText = initialState.searchText;
            state.fromFilterOption = initialState.fromFilterOption;
            state.clients = initialState.clients;
            state.toFilterOption = initialState.toFilterOption;
            state.filters = initialState.filters;

        },
        resetSet: (state) => {
            state.set.items = [];
            state.set.hasMore = true;
        },
        resetUsers: (state) => {
            state.clients.items = [];
            state.clients.hasMore = true;
        },

        setSort: (state, action: PayloadAction<boolean>) => {
            state.set.isDescending = action.payload;
        },
        setNumberOfResults: (state, action: PayloadAction<number>) => {
            state.set.numberOfResults = action.payload;
        },
        setSelectedItems: (state, action: PayloadAction<any[]>) => {
            state.set.selected = action.payload;
        },

        setSelectedUserItems: (state, action: PayloadAction<any[]>) => {
            state.clients.selected = action.payload;
            state.filters = getFilters(state);

        },


        setSearchText: (state, action: PayloadAction<string | undefined>) => {
            state.searchText = action.payload;
        },
        setIsFilteredSet: (state, action: PayloadAction<boolean>) => {
            state.set.isFilteredSet = action.payload;
        },

        setIsFilteredOwnersSet: (state, action: PayloadAction<boolean>) => {
            state.clients.isFilteredSet = action.payload;
        },



        setFromFilterOption: (state, action: PayloadAction<{ value: string, text: string }>) => {
            state.fromFilterOption = action.payload;
            state.filters = getFilters(state);
        },
        setToFilterOption: (state, action: PayloadAction<{ value: string, text: string }>) => {
            state.toFilterOption = action.payload;
            state.filters = getFilters(state);
        },
        addItem: (state, action: PayloadAction<any>) => {
            if (!state.set.isFilteredSet) {
                if (!state.set.hasMore && !state.set.isDescending) {
                    state.set.items.push(action.payload);
                } else if (state.set.isDescending) {
                    state.set.items.unshift(action.payload);
                }
            }
        },
        updateItem: (state, action: PayloadAction<any>) => {
            let selected = state.set.selected;
            if (action?.payload) {
                if (selected.length > 0 && selected.at(0).id == action?.payload?.id) {
                    selected[0] = action?.payload
                }
                var u = state.set.items.findIndex(e => e.id == action?.payload?.id)
                if (u >= 0) {
                    state.set.items[u] = action?.payload
                }
            }

        },

        setMessage: (state, action: PayloadAction<ApiMessage>) => {
            state.message = action.payload;
        },

    },
    extraReducers: (builder) => {

        builder.addCase(getClinetUsers.fulfilled, (state, { payload }) => {
            if (payload) {
                var r = (payload?.success?.usersList.map(val => {
                    return {
                        internalId: val.profile?.internalid,
                        name: (val.profile?.firstname?.value ?? "") + " " + (val.profile?.lastname?.value ?? ""),
                        firstname: (val.profile?.firstname?.value ?? ""),
                        lastname: (val.profile?.lastname?.value ?? ""),
                        username: val.username?.value ?? "",
                        isActive: val.isactive,
                        isConfirmed: val.isconfirmed,

                        createdDate: formatDate(timestampToDate(val.profile?.createddate?.seconds, val.profile?.createddate?.nanos)),
                        addedBy: (val.profile?.addedby?.firstname?.value ?? "") + " " + (val.profile?.addedby?.lastname?.value ?? ""),
                        addedById: val.profile?.addedby?.id?.value,
                        role: val.profile?.role?.name?.value,
                        roleId: val.profile?.role?.id,
                        usertypeId: val.profile?.usertype?.id,
                        usertype: val.profile?.usertype?.name?.value,
                        lastlogin: formatDate(timestampToDate(val.lastlogin?.seconds, val.lastlogin?.nanos)),
                        imageId: val.profile?.image?.id?.value,
                        imageExtension: val.profile?.image?.extension?.value,
                        imageName: val.profile?.image?.name?.value,
                        imageOriginalName: val.profile?.image?.originalname?.value,
                        imagePath: val.profile?.image?.path?.value,
                        imageSize: val.profile?.image?.size?.value ?? 0,
                        imageSource: val.profile?.image?.source?.value,

                    }
                }
                ) as any[])
                //r = (r.concat(...Array(9).fill(r)));
                if (r.length < state.clients.numberOfResults) {
                    state.clients.hasMore = false;
                }
                state.clients.items = state.clients.items.concat(r);
                //console.log(state.items)

            } else {
                state.clients.hasMore = false;
            }
            state.clients.isFetching = false

        })
        builder.addCase(getClinetUsers.rejected, (state, action) => {
            state.clients.isFetching = false;
            if (action.payload) {
                //state.message = action.payload;
            }
        })
        builder.addCase(getClinetUsers.pending, (state, action) => {
            state.clients.isFetching = true;
            // state.message = undefined;
        })



        builder.addCase(getItems.fulfilled, (state, { payload }) => {
            if (payload) {
                var r = (payload?.success?.ordertransactionsList.map(val => {
                    var res = {
                        id: val.id,
                        currencyId: val.currency?.id?.value ?? "",
                        currencyName: val.currency?.name?.value ?? "",
                        currencyCode: val.currency?.code?.value ?? "",
                        currencyDecimalPlaces: val.currency?.decimalplaces?.value ?? undefined,
                        currencyForm: val.currency?.form?.value ?? undefined,
                        currencySymbol: val.currency?.symbol?.value ?? "",
                        amount: val.amount?.value,
                        statusId: val.status?.id?.value,
                        statusCreatedDate: formatDate(timestampToDate(val.status?.createddate?.seconds, val.status?.createddate?.nanos)),
                        statusCreatedById: val.status?.createdby?.id?.value,
                        statusCreatedBy: (val.status?.createdby?.firstname?.value ?? "") + " " + (val.status?.createdby?.lastname?.value ?? ""),
                        sellOrder: undefined as any,
                        buyOrder: undefined as any,
                        buyTransactionId: undefined as any,
                        buyTransactionInternalId: undefined as any,
                        sellTransactionId: undefined as any,
                        sellTransactionInternalId: undefined as any,
                        clientId: val.client?.id?.value,
                        clientName: (val.client?.firstname?.value ?? "") + " " + (val.client?.lastname?.value ?? ""),
                        createdDate: formatDate(timestampToDate(val.createddate?.seconds, val.createddate?.nanos)),
                        addedBy: (val.createdby?.firstname?.value ?? "") + " " + (val.createdby?.lastname?.value ?? ""),
                        addedById: val.createdby?.id?.value,

                        extraFields: [] as DynamicField[],

                             itemId: val.tradeditem?.id?.value ?? undefined,
                        currencyPairId: val.tradeditem?.item?.id?.value,
                        currencyPairName: val.tradeditem?.item?.name?.value,
                        currencyPairBaseCurrencyId: val.tradeditem?.item?.base?.id?.value ?? "",
                        currencyPairBaseCurrencyName: val.tradeditem?.item?.base?.name?.value ?? "",
                        currencyPairBaseCurrencyCode: val.tradeditem?.item?.base?.code?.value ?? "",
                        currencyPairBaseCurrencyDecimalPlaces: val.tradeditem?.item?.base?.decimalplaces?.value ?? undefined,
                        currencyPairBaseCurrencyForm: val.tradeditem?.item?.base?.form?.value ?? undefined,
                        currencyPairBaseCurrencySymbol: val.tradeditem?.item?.base?.symbol?.value ?? "",
                        currencyPairQuoteCurrencyId: val.tradeditem?.item?.quote?.id?.value ?? "",
                        currencyPairQuoteCurrencyName: val.tradeditem?.item?.quote?.name?.value ?? "",
                        currencyPairQuoteCurrencyCode: val.tradeditem?.item?.quote?.code?.value ?? "",
                        currencyPairQuoteCurrencyDecimalPlaces: val.tradeditem?.item?.quote?.decimalplaces?.value ?? undefined,
                        currencyPairQuoteCurrencyForm: val.tradeditem?.item?.quote?.form?.value ?? undefined,
                        currencyPairQuoteCurrencySymbol: val.tradeditem?.item?.quote?.symbol?.value ?? "",
                        itemPrice: val.tradeditem?.price?.value,
                        itemQuantity: val.tradeditem?.quantity?.value,
                        itemSubTotal: val.tradeditem?.subtotal?.value,

                    }
                    if (val?.extrafieldsList) {
                        let count = 0
                        val?.extrafieldsList?.forEach(element => {
                            res.extraFields.push({ key: element.key, label: element.label, type: element.type, value: element.value })
                            count++
                        });
                    }
                    if (val.order?.tradeaction?.value == OrderAction.BUY) {
                        res.buyOrder = val.order?.id?.value;
                        res.sellOrder = val.referenceorder?.id?.value;

                        res.buyTransactionId = val.matchtransaction?.id?.value
                        res.buyTransactionInternalId = val.matchtransaction?.internalid?.value
                        res.sellTransactionId = val.referencetransaction?.id?.value
                        res.sellTransactionInternalId = val.referencetransaction?.internalid?.value

                    } else {
                        res.sellOrder = val.order?.id?.value;
                        res.buyOrder = val.referenceorder?.id?.value;


                        res.buyTransactionId = val.referencetransaction?.id?.value
                        res.buyTransactionInternalId = val.referencetransaction?.internalid?.value
                        res.sellTransactionId = val.matchtransaction?.id?.value
                        res.sellTransactionInternalId = val.matchtransaction?.internalid?.value

                    }

                    return res;


                }
                ) as any[])
                //r = (r.concat(...Array(9).fill(r)));
                let l = [];
                if (state.set.items.length != 0) {
                    l = state.set.items.slice(0, state.set.items.length - 10)
                }
                l = l.concat(r);
                if (r.length < state.set.numberOfResults) {
                    state.set.hasMore = false;
                } else {
                    l = l.concat(...Array(10).fill(null));
                }

                state.set.items = l
                //console.log(state.items)


            } else {
                state.set.hasMore = false;
            }
            state.set.isFetching = false

        })
        builder.addCase(getItems.rejected, (state, action) => {
            state.set.isFetching = false;
            if (action.payload) {
                state.message = action.payload;
            }
        })
        builder.addCase(getItems.pending, (state, action) => {
            state.set.isFetching = true;
            state.message = undefined;
        })


        builder.addCase(updateStatus.fulfilled, (state, { payload }) => {
            state.isChangeStateLoading = false;
            if (payload) {
                state.message = toApiMessage(payload?.response?.success?.message);
                let selected = state.set.selected;
                if (payload?.metadata) {
                    if (selected.length > 0 && selected.at(0).id == payload?.metadata.id) {
                        selected.at(0).statusId = payload?.metadata.status
                        selected.at(0).statusCreatedDate = formatDate(timestampToDate(payload.response?.success?.updateddate?.seconds, payload.response?.success?.updateddate?.nanos))
                        selected.at(0).statusCreatedById = payload?.metadata.current?.profile?.id?.value
                        selected.at(0).statusCreatedBy = payload?.metadata.current?.profile?.firstname?.value + " " + payload?.metadata.current?.profile?.lastname?.value


                    }
                    var u = state.set.items.findIndex(e => e.id == payload?.metadata.id)
                    if (u >= 0) {
                        state.set.items.at(u).statusId = payload?.metadata.status
                        state.set.items.at(u).statusCreatedDate = formatDate(timestampToDate(payload.response?.success?.updateddate?.seconds, payload.response?.success?.updateddate?.nanos))
                        state.set.items.at(u).statusCreatedById = payload?.metadata.current?.profile?.id?.value
                        state.set.items.at(u).statusCreatedBy = payload?.metadata.current?.profile?.firstname?.value + " " + payload?.metadata.current?.profile?.lastname?.value

                    }

                }
            }
        })
        builder.addCase(updateStatus.rejected, (state, action) => {
            state.isChangeStateLoading = false;
            if (action.payload) {
                state.message = action.payload;
            }
        })
        builder.addCase(updateStatus.pending, (state, action) => {
            state.isChangeStateLoading = true;
            state.message = undefined;
        })
    }
})

export const { reset, dismissMessage, setMessage, setSort, setNumberOfResults, resetSet, setSelectedItems, setSearchText, setIsFilteredSet, addItem, updateItem, resetUsers, setFromFilterOption, setToFilterOption, setIsFilteredOwnersSet, setSelectedUserItems, } = orderTransactionsPageSlice.actions

export default orderTransactionsPageSlice.reducer


